module.exports = __webpack_public_path__ + "media/images/riders/small/JOLANDA_NEFF-9efb61e5981b9ddccfd76055c40d2d8d.png";